import axios from "axios";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import CustomedAvatar from "./CustomedAvatar";
import dayjs from "dayjs";

interface User {
  user_id: string;
  total_points: string;
}

const MonthlyRanking = () => {
  const [userLoginState, setUserLoginState] = useRecoilState(userStateAtom);
  const userId = userLoginState.userData.userIdphp;
  const [userRankingData, setUserRankingData] = useState<User[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [sortedUserRankingData, setSortedUserRankingData] = useState<User[]>(
    []
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage] = useState(5);
  const now = dayjs();
  const year = now.year().toString();
  const month = now.format("MM");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://chamstudyland.com/api/fun_learning/getRankingByMonth.php?year=${year}&month=${month}`
        );
        setUserRankingData(response.data);
      } catch {
        setError("데이터를 가져오는데 실패했습니다.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const sortedData = [...userRankingData].sort((a, b) => {
      return parseInt(b.total_points) - parseInt(a.total_points);
    });
    setSortedUserRankingData(sortedData);
  }, [userRankingData]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const filteredData = sortedUserRankingData
    .map((user, index) => ({ ...user, originalRank: index + 1 }))
    .filter((user) =>
      user.user_id.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .slice(0, 50);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const maskUserId = (userId: string): string => {
    if (userId.length <= 2) return userId; // If the user ID is 2 characters or less, return it as is
    return userId.slice(0, 2) + "*".repeat(userId.length - 2);
  };

  return (
    <div>
      <div className="dark:text-slate-200 font-bold text-slate-800 text-xl max-w-sm mx-auto my-5">
        월간랭킹보기
      </div>
      {/* <div className="max-w-sm mx-auto">
  <input
    type="text"
    placeholder="Search by ID"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="w-full px-3 py-2 mb-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-slate-600 dark:border-gray-700"
  />
</div> */}
      <table className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
        <thead className="bg-gray-50 dark:bg-gray-700">
          <tr>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              랭킹
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              아이디
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              포인트
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
          {currentItems.map((user, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900 dark:text-gray-200">
                  #{user.originalRank}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10">
                    <CustomedAvatar id={user.user_id} />
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                      {maskUserId(user.user_id)}
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                  {user.total_points}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-center mb-6">
        <nav className="relative z-0 inline-flex shadow-sm px-5 bg-slate-100 dark:bg-gray-800 rounded-lg">
          {pageNumbers.map((number) => (
            <button
              key={number}
              onClick={() => handlePageChange(number)}
              className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                currentPage === number
                  ? "bg-blue-500 dark:bg-blue-800 text-slate-300 border-none"
                  : "bg-slate-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-none"
              }`}
            >
              {number}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default MonthlyRanking;
